var VIEW_BOX_SIZE = 120;
var NUMBER_OF_RINGS = 6;
var STROKE_WIDTH = VIEW_BOX_SIZE / 12;
var BASE_RADIUS = VIEW_BOX_SIZE / 2 - STROKE_WIDTH / 2;

export { BASE_RADIUS, NUMBER_OF_RINGS, STROKE_WIDTH, VIEW_BOX_SIZE };
//# sourceMappingURL=Logo.contants.js.map
